import { Box, Dialog, DialogTitle, DialogContent, Button, Typography } from "@mui/material";
import { ModalDialogProps } from './PlanSelectorDialog';
import { useState } from "react";
import { deleteProxyApplication } from "../clients/FixieApiClient";
import { toast } from "react-toastify";
import trackEvent from "../utils/trackEvent";

export default (props: ModalDialogProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    const response = await deleteProxyApplication(props.applicationId);
    if (response.ok) {
      trackEvent('delete_proxy_application');
      props.onSuccess();
      toast.success("Proxy application deleted");
    }
    setIsLoading(false);
  }

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>
        <Box component="div" sx={{ minWidth: 280 }}>
          <Typography>Deleting a proxy application will cause any requests using its credentials to fail.
            Make sure you are no longer using this proxy application.</Typography>
          <Box textAlign="right">
            <Button
              disabled={isLoading}
              disableElevation
              variant="text"
              type="submit"
              sx={{ mt: 2, mb: 2, height: "56px" }}
              onClick={props.onClose}
            >
              Cancel
            </Button>
            <Button
              disabled={isLoading}
              disableElevation
              variant="contained"
              type="submit"
              sx={{ mt: 2, mb: 2, height: "56px" }}
              onClick={handleConfirm}
            >
              Delete Proxy Application
            </Button>
          </Box>
        </Box>
      </DialogContent>

    </Dialog >
  );
}
